module.exports = __webpack_public_path__ + "static/summary-bg.85958f0b.png";